import Ellipsis from './ellipsis.vue';
export default Ellipsis;


// WEBPACK FOOTER //
// ./src/components/ellipsis/index.js